<template>
    <div style="text-align: center; padding: 25px; overflow: auto;">
        <div v-if="displayEditor">
            <div style="padding: 0 35px; margin-bottom: 40px;">
                <md-field id="title-input">
                    <md-input v-model="assignmentData.name" @change="updateAssignment()" 
                    maxlength="60" placeholder="Assignment Name" />
                </md-field>
                <md-field id="case-desc-input">
                    <md-textarea v-model="assignmentData.description" @change="updateAssignment()" 
                    placeholder="Assignment Description"
                    md-autogrow maxlength="300"></md-textarea>
                </md-field>
            </div>
            <md-tabs>
                <md-tab md-label="Case List">
                    <hr class="soft">
                    <draggable v-model="assignmentData.caseList" @end="updateAssignment()">
                        <div v-for="(caseID, caseIndex) in assignmentData.caseList" :key="caseIndex">
                            <div v-if="caseData[caseID]" style="cursor: grab;">
                                <md-icon class="drag-handle" style="float: left; cursor: grab;">
                                    drag_handler
                                </md-icon>
                                <a :href="'/classroom/' + classroomID + '/dashboard/' + assignmentData.id + '/' + caseData[caseID].id" target="_blank"
                                style="color: black; font-weight: bold;">
                                    {{caseData[caseID].title}}
                                </a>
                                &nbsp;
                                <span @click="removeCase(caseIndex)" style="float: right; cursor: pointer;">
                                    <md-icon class="md-accent">cancel</md-icon>
                                </span>
                                <br>
                                Case #{{caseIndex + 1}}
                                <hr class="soft">
                            </div>
                        </div>
                    </draggable>
                    <md-button class="md-raised md-primary" @click="addCase">
                        Add Case
                    </md-button>
                </md-tab>
                <md-tab md-label="Settings">
                    <br>
                    <div v-if="assignmentData.mandatory">
                        Indicates to learners that this assignment is mandatory.
                    </div>
                    <div v-else>
                        Indicates to learners that this assignment is optional.
                    </div>
                    <md-switch v-model="assignmentData.mandatory" @change="updateAssignment()">
                        Mandatory
                    </md-switch>
                    <hr class="soft">
                    <md-button class="md-raised md-accent" @click="deleteAssignment()">
                        Delete Assignment
                    </md-button>
                </md-tab>
            </md-tabs>
        </div>
        <div v-else>
            <h2>{{assignmentData.name}}</h2>
            <p>
                <i>{{assignmentData.description}}</i>
            </p>
            <hr class="soft">
            <div v-for="(caseID, caseIndex) in assignmentData.caseList" :key="caseIndex">
                <div v-if="caseData[caseID]">
                    <a :href="'/cases/' + caseData[caseID].id + '?classroom=' + classroomID + '&assignment=' + assignmentData.id" 
                    target="_blank" style="color: black; font-weight: bold;">
                        {{caseData[caseID].title}}
                        <md-icon class="md-primary case-play-btn" v-if="classroomReviews.filter(x => x.cid == caseID && x.reporting.assignmentID == assignmentData.id).length < 1">
                            play_circle_filled
                        </md-icon>
                        <md-icon v-else class="case-play-btn" style="color: green">
                            check_circle
                        </md-icon>
                    </a>
                    <br>
                    Case #{{caseIndex + 1}}
                    <hr class="soft">
                </div>
            </div>
        </div>
        <!-- Weird hack needed for reactivity -->
        <span style="display: none">{{caseX}}</span>
    </div>
</template>

<script>
    import APIRequests from "../APIRequests.js"
    import draggable from 'vuedraggable'
    import ObjectID  from "bson-objectid"

    export default {
        components: {
            draggable
        },
        props: {
            classroomID: {
                type: String
            },
            displayEditor: {
                type: Boolean
            },
            assignmentData: {
                type: Object
            },
            classroomReviews: {
                type: Array
            }
        },
        computed: {
            caseX: function(){
                this.fetchCaseData()
                return this.assignmentData
            }
        },
        data: function(){
            return {
                caseData: {}
            }
        },
        methods: {
            addCase: function(){
                let caseURL = prompt("Please paste the URL of the case you wish to add")
                if(!caseURL) return
                var pattern = new RegExp("https?://" + window.location.host + "/(?:cases)?(?:editor)?/([\\w\\d]+)(?:\\?.*)?");
                let urlMatches = caseURL.match(pattern)
                if(!urlMatches || urlMatches.length != 2){
                    this.$emit("notify", "Case URL improperly formatted!")
                    return
                }
                let caseID = urlMatches[1]
                if(this.assignmentData.caseList.indexOf(caseID) != -1){
                    this.$emit("notify", "Case already exists in this assignment!")
                    return
                } 
                if(!ObjectID.isValid(caseID)){
                    this.$emit("notify", "Invalid case URL please try again!")
                    return
                }
                this.assignmentData.caseList.push(caseID)
                this.updateAssignment()
            },
            removeCase: function(caseIndex){
                if(!confirm("Are you sure you want to remove this case from the assignment?")) return
                let updatedCaseList = this.assignmentData.caseList
                updatedCaseList.splice(caseIndex, 1)
                this.$set(this.assignmentData, "caseList", updatedCaseList)
                this.updateAssignment()
            },
            fetchCaseData: function(){
                this.assignmentData.caseList.forEach((caseID) => {
                    if(this.caseData[caseID]) return
                    var api_url = this.$store.state.api_url + "/api/cases/" + caseID
                    APIRequests.getJSONData(
                        api_url,
                        this.$store.state.jwtToken
                    ).then((data) => {
                        this.$set(this.caseData, caseID, data)
                    })
                })
            },
            updateAssignment: function(){
                if(this.assignmentData.name.trim().length < 1){
                    this.$set(this.assignmentData, "name", "Unnamed Assignment")
                }
                this.$emit("updateAssignment", this.assignmentData)
            },
            deleteAssignment: function(){
                if(!confirm("Are you sure you want to delete this assignment?")) return
                this.$emit("deleteAssignment")
            }
        }
    }
</script>

<style scoped>
    #title-input input{
		font-size: 120%;
		text-align: center;
    }
    .md-tabs >>> .md-tabs-content{
        height: auto !important;
    }
    .case-play-btn{
        float: right; 
        cursor: pointer; 
        font-size: 250% !important; 
        margin-top: 8px; 
        margin-left: -40px; 
        margin-right: 10px;
    }
</style>
